import {
  EqualisationSection,
  FeesEqualisationTreatment,
} from 'further-types/lp/equalisation';

export const EqualisationSectionLabels = {
  [EqualisationSection.Commitments]: 'Commitments',
  [EqualisationSection.Investments]: 'Investments',
  [EqualisationSection.Expenses]: 'Expenses',
  [EqualisationSection.Income]: 'Income',
  [EqualisationSection.ManagementFees]: 'Management Fees',
  [EqualisationSection.ActionLinkedCapitalActions]:
    'Action Linked Capital Actions',
  [EqualisationSection.GeneralCapitalCalls]: 'General Capital Calls',
  [EqualisationSection.EqualisationInterest]: 'Equalisation Interest',
  [EqualisationSection.Summary]: 'Summary',
};

export const FeesEqualisationTreatmentLabels: Record<
  FeesEqualisationTreatment,
  string
> = {
  [FeesEqualisationTreatment.Full]: 'Full catch-up',
  [FeesEqualisationTreatment.Partial]: 'Partial catch-up',
  [FeesEqualisationTreatment.None]: 'No catch-up (from close date)',
};
